// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3f3W2","title":"FrontImage_title__3k_4Y"};